module.exports = __webpack_public_path__ + "img/Bannerkill.ac46119a.jpg";